module.exports = {

  /**
   * @param _$target {HTMLElement}
   * @param _$$group {HTMLElement}
   * @return {integer} index
   */
  getIndex: (_$target, _$$group) => {
    for(var i_ = 0; _$$group.length > i_; i_++) {
      if(_$$group[i_] === _$target) {
        return i_;
        break;
      }
    }
  },

  /**
   * @param _$target {HTMLElement}
   * @param _$$group {HTMLElement}
   */
  getScrollBarWidth: () => {
    return parseFloat(window.innerWidth) - parseFloat(document.body.clientWidth);
  },

  /**
   * @param el {HTMLElement}
   * @return {object} width & height
   */
  getSize: (el) => {
    const style = getComputedStyle(el, null);
    const w = el.clientWidth - parseFloat(style.paddingRight) - parseFloat(style.paddingLeft);
    const h = el.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
    return { w, h };
  },

  /**
   * @param el {HTMLElement}
   * @return {object} width & height
   */
  getClientSize: (el) => {
    const style     = getComputedStyle(el, null);
    const boxSizing = style.boxSizing;
    let w = 0;
    let h = 0;
    if(boxSizing.match(/(border-box|padding-box)/)) {
      w = el.clientWidth;
      h = el.clientHeight;
    } else {
      w = el.clientWidth - parseFloat(style.paddingRight) - parseFloat(style.paddingLeft);
      h = el.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      return { w, h };
    }
  },

  /**
   * @param el {HTMLElement}
   * @return {object} width & height
   */
  getOffsetWidth: (el) => {
    const style     = getComputedStyle(el, null);
    const boxSizing = style.boxSizing;
    let w = 0;
    let h = 0;
    if(boxSizing.match(/(border-box)/)) {
      w = el.offsetWidth;
      h = el.offsetHeight;
    } else {
      w = el.offsetWidth - parseFloat(style.paddingRight) - parseFloat(style.paddingLeft) - parseFloat(style.borderRightWidth) - parseFloat(style.borderLeftWidth);
      h = el.offsetHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom) - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth);
    }
    return { w, h };
  },

  /**
   * @param el {HTMLElement}
   * @return {object} margin
   */
  getMargin: (el) => {
    const style = getComputedStyle(el, null);
    return {
      top   : parseFloat(style.marginTop),
      right : parseFloat(style.marginRight),
      bottom: parseFloat(style.marginBottom),
      left  : parseFloat(style.marginLeft),
    }
  },

  /**
   * @param el {HTMLElement}
   * @return {object} padding
   */
  getPadding: (el) => {
    const style = getComputedStyle(el, null);
    return {
      top   : parseFloat(style.paddingTop),
      right : parseFloat(style.paddingRight),
      bottom: parseFloat(style.paddingBottom),
      left  : parseFloat(style.paddingLeft),
    }
  },

  /**
   * @param el {HTMLElement}
   * @return {object} border-width
   */
  getBorderWidth: (el) => {
    const style = getComputedStyle(el, null);
    return {
      top   : parseFloat(style.borderTopWidth),
      right : parseFloat(style.borderRightWidth),
      bottom: parseFloat(style.borderBottomWidth),
      left  : parseFloat(style.borderLeftWidth),
    }
  },

  /**
   * @param el {HTMLElement}
   * @return {string} background-image url
   */
  getBgImg: (el) => {
    const bgImg = getComputedStyle(el, null).backgroundImage;
    if(bgImg !== 'none') {
      const bgImgPath = bgImg.match(/^url\(['"]?(.+[0-9a-zA-Z])['"]?\)$/);
      if( typeof bgImgPath !== 'undefined' && bgImgPath !== null ) {
        return bgImgPath[1];
      }
    }
  },

}



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/modules/element-state.js
 **/